"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMenuDataOfTab = exports.genCellsConfigMap = exports.getCellsConfigOfSearch = exports.filterMinUnitOfSearch = exports.getSearchStrOfState = exports.getSeachStrByTab = void 0;

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 获取 tab 下对应的搜索 Key
 * @param {*} tabKey
 */
var getSeachStrByTab = function getSeachStrByTab(tabKey) {
  return 'search_' + tabKey;
};
/**
 * 根据当前选择的 tab 获取对应的搜索状态
 * @param {*} state
 */


exports.getSeachStrByTab = getSeachStrByTab;

var getSearchStrOfState = function getSearchStrOfState(state) {
  var key = getSeachStrByTab(state.activeTab);
  return state[key];
};
/**
 * 按照输入内容，过滤最小单位的字段列表
 * @param {Array} unitArr
 * @param {string} str
 * @return {Array} 过滤后的字段配置的列表
 */


exports.getSearchStrOfState = getSearchStrOfState;

var filterMinUnitOfSearch = function filterMinUnitOfSearch() {
  var unitArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var str = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  str = _lodash["default"].trim(str); // if (!str) {
  //     return unitArr;
  // }

  var returnlist = unitArr.filter(function (fieldConfig) {
    //privilegeContains支持直接写字段名称
    if (fieldConfig.displayName.indexOf(str) != -1) {
      return true;
    }
  });
  return returnlist;
};
/**
 * 根据搜索内容，过滤指标
 */


exports.filterMinUnitOfSearch = filterMinUnitOfSearch;
var getCellsConfigOfSearch = (0, _memoizeOne["default"])(function () {
  var originConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var tabKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var str = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  str = _lodash["default"].trim(str);

  var filteredRespData = _objectSpread({}, originConfig);

  var filterConfig = function filterConfig(configs, rootPath) {
    var searchStr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var list = configs.list,
        _configs$columns = configs.columns,
        columns = _configs$columns === void 0 ? [] : _configs$columns,
        name = configs.name; //一直到columns才是真正的指标的配置，其他都是各种层级的分类信息

    if (list) {
      var filteredlist = [];
      list.forEach(function (listItem) {
        var listItemInfo = filterConfig(listItem, [rootPath, 'list', filteredlist.length].join('.'), searchStr);

        if (listItemInfo) {
          filteredlist.push(listItemInfo);
        }
      });

      if (filteredlist.length > 0) {
        return {
          name: name,
          path: [rootPath, 'list'].join('.'),
          list: filteredlist
        };
      } else {
        return null;
      }
    } else if (columns) {
      var filteredColumns = filterMinUnitOfSearch(columns, searchStr);

      if (filteredColumns.length > 0) {
        return {
          name: name,
          path: [rootPath, 'columns'].join('.'),
          columns: filteredColumns
        };
      }

      return null;
    }
  };

  var info = filterConfig(originConfig[tabKey], [tabKey].join('.'), str);

  if (info) {
    filteredRespData[tabKey] = info;
  } else {
    filteredRespData[tabKey] = _objectSpread({}, filteredRespData[tabKey], {
      list: []
    });
  }

  return filteredRespData;
});
/**
 * 生成自定义配置 map
 */

exports.getCellsConfigOfSearch = getCellsConfigOfSearch;

var genCellsConfigMap = function genCellsConfigMap() {
  var cellsConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var map = {}; // 递归 cell 配置

  var recursionConfig = function recursionConfig() {
    var itemConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var list = itemConfig.list,
        columns = itemConfig.columns; //一直到columns才是真正的指标的配置，其他都是各种层级的分类信息

    if (list && list.length > 0) {
      list.forEach(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        recursionConfig(item);
      });
    } else if (columns && columns.length > 0) {
      columns.forEach(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (item.name) {
          // 直接使用原先的配置对象
          map[item.name] = item;
        }
      });
    }
  };

  Object.keys(cellsConfig).forEach(function (key) {
    recursionConfig(cellsConfig[key]);
  });
  return map;
};

exports.genCellsConfigMap = genCellsConfigMap;

var getMinUnitOfMetuData = function getMinUnitOfMetuData(columnsConfig, relate2Root) {
  return {
    label: columnsConfig.name,
    key: columnsConfig.path || relate2Root
  };
};
/**
 * 获取 tab 下对应的菜单数据
 */


var getMenuDataOfTab = (0, _memoizeOne["default"])(function (cellsConfig) {
  var tabKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'system_categories';

  var getListMap = function getListMap(listConfig, pathRelated2Root) {
    if (listConfig.columns) {
      var ret = getMinUnitOfMetuData(listConfig, [pathRelated2Root].join('.'));
      return ret;
    } else if (listConfig.list) {
      var _ret = listConfig.list.map(function (listItem, index) {
        return getListMap(listItem, [pathRelated2Root, 'list', index].join('.'));
      });

      return {
        label: listConfig.name,
        key: listConfig.path || [pathRelated2Root, 'list'].join('.'),
        data: _ret
      };
    }
  };

  var data = cellsConfig[tabKey].list.map(function (tabConfig, listIndex) {
    return getListMap(tabConfig, [tabKey, 'list', listIndex].join('.'));
  });
  return data;
});
exports.getMenuDataOfTab = getMenuDataOfTab;